import React, { useContext, useEffect } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";
import { InterviewGoalTemplate } from "../../classes/goal_template_interview_class";
import { InterviewFormContext } from "../../hooks/InterviewFormContext";

export const InterviewPreview = () => {
  const { t, DBObject, uuid } = useContext(TMDataContext);
  const { goalState, setGoalState } = useContext(InterviewFormContext);

  useEffect(() => {
    setGoalState((prevState) => {
      let newGoalObject = new InterviewGoalTemplate(prevState);
      return newGoalObject;
    });
  }, []);

  const displayThreshold = () => {
    if (goalState.achievementTarget == 1) {
      return (
        <span className="goal-value-preview">
          {t(
            `views.goals.contexts.${goalState.type.handle}.threshold_not_applicable`
          )}
        </span>
      );
    } else {
      return (
        <span className="goal-value-preview">
          {t(
            `views.goals.contexts.${goalState.type.handle}.amber_status_start`
          )}{" "}
          <span className="goal-variables-preview">
            {goalState.achievementThreshold}
          </span>{" "}
          {t(
            `views.goals.contexts.${goalState.type.handle}.status_end_${
              goalState.achievementThreshold == 1 ? "single" : "multiple"
            }`
          )}
        </span>
      );
    }
  };

  const interviewList = () => {
    return goalState.selectedInterviewSets.map((set) => {
      var currentIndex = goalState.selectedInterviewSets.indexOf(set);
      var elementClass =
        goalState.selectedInterviewSets.length == currentIndex + 1
          ? "interview-list-element-preview"
          : "interview-list-element-preview goal-form-underline";
      return (
        <div key={uuid()} className={elementClass}>
          {" "}
          <div className="interview-list-element-number">
            {currentIndex + 1}
          </div>
          <div className="interview-list-element-name">{set.name()}</div>
        </div>
      );
    });
  };

  const showRepeatAmount = () => {
    return (
      <div className="goal-form-input-row preview-row ">
        <span className="goal-input-area-title preview-title">
          {t("views.goals.headings.occurrences")}
        </span>

        {goalState.continuous ? (
          <span className="goal-value-preview">
            {t("views.goals.contexts.occurrence_continuous")}
          </span>
        ) : (
          <>
            <span className="goal-value-preview">
              {t("views.goals.contexts.occur")}
            </span>
            <span className="goal-variables-preview">
              &nbsp;&nbsp;{goalState.occurrenceAmount}
              &nbsp;&nbsp;
            </span>
            <span className="goal-value-preview">
              {goalState.occurrenceAmount > 1
                ? t("views.goals.contexts.occur_times_multiple")
                : t("views.goals.contexts.occur_times_single")}{" "}
            </span>
          </>
        )}
      </div>
    );
  };

  return (
    <div className="row w-100" style={{ flex: 1 }}>
      <div className="col-md-12 col-sm-6">
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {t("views.goals.headings.name")}
          </span>
          <span className="goal-value-preview">{goalState.name}</span>
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {t("views.goals.headings.user")}
          </span>
          <span className="goal-value-preview">
            {goalState.user.lastName}, {goalState.user.firstName}
          </span>
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {t("views.goals.headings.type")}
          </span>
          <span className="goal-value-preview">{goalState.type.label}</span>
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {" "}
            {t("views.goals.headings.description")}
          </span>
          <span style={{ maxWidth: "450px" }} className="goal-value-preview">
            {goalState.description == ""
              ? t("views.goals.contexts.no_description")
              : goalState.description}
          </span>
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {t("views.goals.headings.interviews")}
          </span>
          <span className="goal-value-preview embedded-list">
            {interviewList()}
          </span>
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {t("views.goals.headings.achievement")}:
          </span>
          <span className="goal-value-preview">
            {t(
              `views.goals.contexts.${goalState.type.handle}.achievement_status_start`
            )}{" "}
            <span className="goal-variables-preview">
              {goalState.achievementTarget}
            </span>{" "}
            {t(
              `views.goals.contexts.${goalState.type.handle}.status_end_${
                goalState.achievementTarget == 1 ? "single" : "multiple"
              }`
            )}
          </span>
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {t("views.goals.headings.amber_status")}
          </span>
          {displayThreshold()}
        </div>
        <div className="goal-form-input-row preview-row">
          <span className="goal-input-area-title preview-title">
            {t("views.goals.headings.occurrence_frequency")}
          </span>
          <span className="goal-value-preview">
            <span className="goal-variables-preview">
              {goalState.occurrenceFrequency.label}{" "}
            </span>
          </span>
        </div>
        {showRepeatAmount()}
        {DBObject.ConfigVariables.leaderboards_enabled == "true" ? (
          <div className="goal-form-input-row preview-row goal-form-no-underline">
            <span className="goal-input-area-title preview-title">
              {t("views.goals.headings.leaderboard")}
            </span>
            <span className="goal-value-preview">
              {goalState.leaderboardEnabled
                ? t("views.goals.contexts.Leaderboard.enabled")
                : t("views.goals.contexts.Leaderboard.disabled")}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
};
